<template>
    <div class="img-depot-tab">
        <el-tabs v-model="tabActive" type="card" @tab-click="handleClick">
            <el-tab-pane label="票面背景图" name="imgDepot-background"></el-tab-pane>
            <el-tab-pane label="系统图库" name="imgDepot-system"></el-tab-pane>
        </el-tabs>
        <div class="img-depot-content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tabActive: null
        }
    },
    watch:{
        $route: {
            handler: function() {
                this.tabActive = this.$route.name;
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        handleClick(tab) {
            const {name} = tab;
            if(name === this.$route.name) {
                return;
            }

            this.$router.replace({name})
        }
    },
}
</script>

<style lang="scss" scoped>
.img-depot-tab ::v-deep .el-tabs .el-tabs__header {
    margin: 0 -20px;
    padding: 0 20px;
}
.img-depot-content {
    margin-top: 20px;
}
</style>